import axios from "axios";

export const listLatestGoldPrice = async () => {
  return await axios.get(
    `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/list-latest-gold-price`
  );
};
